import {WComplexMeasurementUnits} from "./complexunit";
import {WPolicy, WProtocol} from "./policy";


export enum FeatureType {
  VitalSigns = "VITALSIGNS",
  Complication = "COMPLICATION",
  GeneticMutations = "GENETIC_MUTATIONS",
  Signs = "SIGNS",
  Imaging = "IMAGING",
  SymptomComplaint = "SYMPTOM_COMPLAINT",
  LaboratoryTests = "LABORATORY_TESTS",
  RiskFactors = "RISK_FACTORS",
  Exposure = "EXPOSURE",
  Disorder = "DISORDER",
  GeneralFactors = "GENERAL_FACTORS",
  History = "HISTORY",
  Treatment = "TREATMENT",
}

// Type of rules. Most rules are nost If/Then rules and fall under the "Association" feature
export enum RuleType {
  Incidence = "INCIDENCE",
  LiveBirth = "LIVE_BIRTH",
  Prevalence = "PREVALENCE",
  Mortality = "MORTALITY",
  Association = "ASSOCIATION",
  RiskLift = "RISK_LIFT", // TODO, should be removed
  HealthyControl = "HEALTHY_CONTROL",
}

// Possible templates - each of these has a support in the UX for more friendly rule decleration
export enum RuleTemplateType {
  VitalSigns = "VITALSIGNS",
  AssoicatedCondition = "ASSOCIATED_CONDITION",
  Complication = "COMPLICATION",
  GeneticMutations = "GENETIC_MUTATIONS",
  Signs = "SIGNS",
  Imaging = "IMAGING",
  SymptomComplaint = "SYMPTOM_COMPLAINT",
  Etiology = "ETIOLOGY",
  LaboratoryTests = "LABORATORY_TESTS",
  RiskFactors = "RISK_FACTORS",
  Exposure = "EXPOSURE",
  RiskLift = "RISK_LIFT",
  Disorder = "DISORDER",
  GeneralFactors = "GENERAL_FACTORS",
  History = "HISTORY",
  Incidence = "INCIDENCE",
  LiveBirth = "LIVE_BIRTH",
  Prevalence = "PREVALENCE",
  Mortality = "MORTALITY",
  HealthyControl = "HEALTHY_CONTROL",
  Treatment = "TREATMENT",
  Advanced = "ADVANCED",
  Custom = "CUSTOM"
}

// FuncctionsAs is a tag (optionally) attached to a rule feature HINTING on the category the rule should appaer under
export enum FunctionsAs {
  AssoicatedCondition = "ASSOCIATED_CONDITION",
  Complication = "COMPLICATION",
  Etiology = "ETIOLOGY",
  RiskFactors = "RISK_FACTORS",
  RiskLift = "RISK_LIFT",
  Exposure = "EXPOSURE",
  History = "HISTORY",
  UseFeatureType = "UseFeatureType",
}

export enum CausalDirection {
  SOURCE_CAUSE_TARGET = "SOURCE_CAUSE_TARGET",
  TARGET_CAUSE_SOURCE = "TARGET_CAUSE_SOURCE",
  ASSOCIATION = "ASSOCIATION"
}

export enum EntityPhase {
  NEW = "NEW",
  CONFIRMED = "CONFIRMED",
  DECLINED = "DECLINED"
}

export enum PanelFilterType {
  OWN_CURATED = "OWN_CURATED" , CURATED_PARENT = "CURATED_PARENT" , ORPHAN_DISEASE = "ORPHAN_DISEASE"
}

export enum RelationFilterType {
  ALL = "ALL" , IN_USE = "IN_USE"
}

/***
 * @Deprecated
 */
export enum RateUnits {
  PERCENT, LIFETIME_PERRCENT, RISK, LIFT, PREVALENCE, INCIDENCE, LIVE_BIRTH, SPECIFICITY, ODDS_RATIO,
}

export enum WMeasurementUnits {
  NA = "NA",

  // pure number
  Units = "Units",
  MilliUnits = "MilliUnits",  //Unit	unit	Units	IU	EU	cells	10^3	10^6	mU
  MicroUnits = "MicroUnits",
  KiloUnits = "KiloUnits",
  MegaUnits = "MegaUnits",
  GigaUnits = "GigaUnits",

  Milliequivalent = "Milliequivalent",

  Mole = "Mole",
  MilliMole = "MilliMole",
  NanoMole = "NanoMole",
  PicoMole = "PicoMole",
  MilliOsmolality = " MilliOsmolality",

  Percent = "Percent",

  // length
  Millimeters = "Millimeters",
  Centimeters = "Centimeters",
  Meters = "Meters",
  Inches = "Inches",
  Feet = "Feet",

  // area
  MeterSquare = "MeterSquare",

  // Volume
  Liter = "Liter",
  Deciliter  = "Deciliter",
  Milliliter  = "Milliliter",
  Microliter  = "Microliter",
  Femtoliter  = "Femtoliter",

  // weight
  Grams = "Grams",
  Picograms = "Picograms",
  Nanograms = "Nanograms",
  Micrograms = "Micrograms",
  Milligrams = "Milligrams",
  Kilograms = "Kilograms",
  Pounds = "Pounds",

  // pressure
  MmHg = "MmHg",

  // time
  Seconds = "Seconds",
  Minutes = "Minutes",
  Hours = "Hours",
  Days = "Days",
  Weeks = "Weeks",
  Months = "Months",
  Years = "Years",

  // special
  KgBodyWeight = "KgBodyWeight",
  PercentOfNormal = "PercentOfNormal",
  GramHemoglobin = "GramHemoglobin",
  GramCreatinine = "GramCreatinine",
  KilogramH2O = "KilogramH2O",
  Pack = "Pack",

  // temprature
  Celsius = 'Celsius',
  Fahrenheit = 'Fahrenheit',

  //logical
  Priority = "Priority",

  //Frequency
  BeatsPerMinute = "BeatsPerMinute",
  RespirationsPerMinute = "RespirationsPerMinute",
  Times = "Times",
}

export enum WMeasurementDimension {
  Pure = "Pure",
  Time = "Time",
  Length = "Length",
  Volume = "Volume",
  Weight = "Weight",
  Area = "Area",
  Mole = "Mole",
  Unit = "Unit",
  Pressure = "Pressure",
  Temperature = "Temperature",
  Special = "Special",
  Frequency = "Frequency"
}

export enum UpdateType {
  CREATE = "CREATE",
  UPDATE = "UPDATE",
  DELETE = "DELETE",
}

// Whether a featute is in the IF part (SOURCE) or THEN part (target) of a rule
export enum ActsAs {
  SOURCE = "SOURCE",
  TARGET = "TARGET",
}

// In case of causal relation (in fact we treat all ruls as causal) this indicares if the feature is the CAUSE or the OUTCOME
export enum PerformsAs {
  CAUSE = "CAUSE",
  OUTCOME = "OUTCOME",
}

export enum KnownFeature {
  POPULATION = "POPULATION",
  LIVEBIRTH = "LIVEBIRTH",
  DEATH = "DEATH",
  SUBTYPE = "SUBTYPE"
}

//. specify at least one of low/high and at least one of units/complexUnits
export interface WMeasurementRange {
  low?: number,
  high?:number,
  units?: WMeasurementUnits,
  complexUnits?: WComplexMeasurementUnits,
}


// Subset of the database (to be sent along with a response helping)
export class WStore {
  knownEntities?: { [name: string]: any };
  ruleValues?: WRuleValue[];
  features?: WFeature[];
  entityTranslations: WEntityTranslation[];
  attributes?: WAttribute[];
  procedures?: WProcedure[];
  relations?: WRelation[];
  citations?: WCitation[];
  panels?: WPanel[];
  discussions?: WDiscussion[];
  commits?: WCommit[];
  piles?: WPile[];
  users?: WUser[];
  snomedConcepts?: WSnomedConcept[];
  loincComponents?: WLoincComponent[];
  policies?: WPolicy[];
  protocols?: WProtocol[];
  commitid: string;
  commitSerial: number;
  revision: string;
}

export interface WRepositoryEntitiesPage {
  // TODO, replace with WFeature
  repositoryEntities: WRepositoryEntity[];
}

export interface WFeaturePage {
  feature: WFeature;
  childids: string[];
  ruleids: string[];
  store: WStore;
}

export interface WPivotTablePage {
  featureids: string[];
  level: number;
  rows: WPivotRow[];
  store: WStore;
}

export interface WPivotRow {
  featureid: string;
  actsAs: ActsAs;
  performsAs: PerformsAs;
  ruleType: RuleType;
  templateType: RuleTemplateType;
  functionsAs: FunctionsAs;
  probs: number[];
}

export interface WPivotPathsPage {
  startFeatureid: string;
  endFeatureid: string;
  prob: number;
  paths: WFeaturePath[];
  store: WStore;
}

export interface WFeaturePath {
  startFeatureid: string;
  steps: WFeaturePathStep[];
  p: number;
  score?: number;
  value?: number;
}

export interface WFeaturePathStep {
  actsAs: ActsAs;
  node: WFeatureNode;
  ruleValueid: string;
  prob: number;
}

export interface WFeatureNode {
  featureid: string;
  procedureid?: string;
  attributeid?: string;
  history?: boolean;
}

export interface WFeatureEditPage {
  // TODO, replace with WFeature
  feature: WFeature;
  store: WStore;
  childids: string[];
  children: WFeature[];
}

export interface WProcedureEditPage {
  // TODO, replace with WFeature
  procedure: WProcedure;
  store: WStore;
}

export interface WAttributeEditPage {
  // TODO, replace with WFeature
  attribute: WAttribute;
  store: WStore;
}

export interface WPanelEditPage {
  // TODO, replace with WFeature
  panel: WPanel;
  store: WStore;
}

export interface WRelationEditPage {
  // TODO, replace with WFeature
  relation: WRelation
  store: WStore;
}


export interface WPanelEditPage {
  // TODO, replace with WFeature
  panel: WPanel;
  store: WStore;
}

export interface WCasePage {
  wcase: WCase;
  store: WStore;
}

export interface WCasesPage {
  cases: WCase[];
  store: WStore;
  totalCount: number;
}

export interface WRulePage {
  ruleValue: WRuleValue;
  rule: WRule;
  ruleValues: WRuleValue[];
  store: WStore;
}

export interface WModeratePage {
  commits: WCommit[];
  store: WStore;
}

export interface WCommitsPage {
  commits: WCommit[];
  store: WStore;
  totalCount: number;
}

export interface WCommitPage {
  commit: WCommit;
  enableApprove: boolean;
  enableReject: boolean;
  historyCommitids: string[],
  store: WStore;
}

export interface WDiagnosePage {
  diagnoseid: string;
  evidences: WEvidence[];
  panelids: string[];
  status: string;
  diseaseProbs: WDiagnoseGoalProb[];
  complicationProbs: WDiagnoseGoalProb[];
  complexProbs: WDiagnoseGoalProb[];
  majorProbs: WDiagnoseGoalProb[];
  testValues: WDiagnoseTestValue[];
  store: WStore;
}

export interface WGoalReasonPage {
  disorderids: string[];
  evidences: WEvidence[];
  panelids: string[];
  paths: WFeaturePath[];
  store: WStore;
}

export interface WTestReasonPage {
  goalProbs: WDiagnoseGoalProb[];
  evidences: WEvidence[];
  panelids: string[];
  test: WFeatureNode;
  paths: WFeaturePath[];
  store: WStore;
}

export interface WRepositoryEntity {
  id: string;
  name: string;
}

export interface WEntity {
  id: string;
  phase?: EntityPhase;
  commitsHistory?: WCommit[];
  history?: WEntityHistory[];
  updateType?: UpdateType;
  enabled?: boolean;
}

export interface WEntityHistory {
  id: string;
  phase?: EntityPhase;
  commits?: WCommit[];
  updateType?: UpdateType;
}

export interface WQualifiedEntity {
  qualifiers?: WFeatureQualifier[];
}

export interface WNamedEntity extends WEntity, WQualifiedEntity {
  name: string;
  terms: WTerm[];
}

export interface WPileEntity extends WEntity {
  pileid?: string;
  pileids?: string[];
  commits?: Array<WCommit>;
  discussions?: WDiscussion[];
}

export interface WRule extends WEntity {
  ruleType: RuleType;
  templateType: RuleTemplateType;
  isPerformReversed: boolean;
  rateUnits: RateUnits;
  features: WRuleFeature[];
}

export interface WPileEntityStore {
  entity: WPileEntity,
  store: WStore
}


export interface WRuleValue extends WPileEntity {
  publication: WPublication;

  // TO BE REMOVED:
  probs?: WRuleProb[];

  // TO BE ADDED:
  ruleRate?: WRuleRate;
  rule?: WRule;
  citationid?: string;
  citation?: WCitation;
  citationsCount?: number;
  isLatestCitation?: boolean;
  llmMaster?: boolean;
}

export enum DistributionType {
  IQR, Normal
}

export interface WSubFeature extends WQualifiedEntity {
  measurementRange?: WMeasurementRange;
  cost?: number;
  definedAs?: WQualifiedFeature[];
  situation?: WQualifiedFeature[];
}

export interface WFeature extends WPileEntity, WNamedEntity, WSubFeature {
  featureType: FeatureType;
  snomedid?: string;
  loincid?: string;
  procedureids?: string[];
  panelids?: string[];
  parentids: string[];
  inferredParentids?: string[]; // calculated by the reasoner from parents+qualifiers
  ancestorids?: string[];

  // TO BE REMOVED PROPERTIES:
  values?: string[];
  valuesType?: string;
  attributeids?: string[];

  // TO BE ADDED  PROPERTIES:

  // "qualifiers" list all "snomed-relations" that this feature is part of their domain
  //todo temporarily make all these optional
  qualiifer?: boolean; // True if this is a qualifier only feature (meaningless by its own). Example: "Bi-Lateral"
  childids?: string[];

  conceptType?: ConceptType;
  abstrakt?: boolean;
  enabled?: boolean;
  children?: WFeature[]; // after inflate
  parents?: WFeature[]; // after inflate
  inferredParents?: WFeature[]; // after inflate
  ancestors?: WFeature[]; //after inflate
  belongsToPanels?: WFeature[]; //after inflate

  externalData?: ExternalData;

  panelFindings?: WQualifiedFeature[];

  childrenSetType?: ChildrenSetType;
  fullyDefined?: boolean;
  uniq?: boolean,
  groupBy?: boolean,
  patientFinding?: boolean,
  patientFacingFinding?: boolean,
  groupHeader?: GroupHeader,
  inferredQualiifers?: WFeatureQualifier[];

  subFeatures?: WSubFeature[];

  // list of other features which their "definedAs" relies on this feature
  cancidateDefinedAs?: WFeature[];

  // output only stats (for the editor)
  rulesCount?: number;
  citationsCount?: number;

  synonyms?: Synonym[];
  //former sub-feature
  anonymous?: boolean;
}

export interface WEntityTranslation extends WPileEntity {
  entityid: string;
  langcode: string;
  terms: WTerm[];
  synonyms: Synonym[];
}

export interface SaveEntityTranslation {
  entityid: string;
  langCode: string;
  terms: WTerm[];
  synonyms: Synonym[];
}

export enum ChildrenSetType {
  NONE="NONE", DISJOINT = "DISJOINT", COMPLETE = "COMPLETE", COMPLETE_WITH_MULTIPLE_SELECTS = "COMPLETE_WITH_MULTIPLE_SELECTS"
}

export enum ConceptType {
  FEATURE = "FEATURE", QUALIFIER = "QUALIFIER", PROCEDURE = "PROCEDURE", PANEL="PANEL", COMPANION="COMPANION"
}

export enum GroupHeader {
  NEVER_GROUP_HEADER = "NEVER_GROUP_HEADER",
  HEADER_OF_FLAT_GROUPS_ONLY = "HEADER_OF_FLAT_GROUPS_ONLY",
  NORMAL_HEADER = "NORMAL_HEADER",
  NEVER_GROUP_CHILD = "NEVER_GROUP_CHILD"
}

export interface WProcedure extends WPileEntity, WNamedEntity {
  procedureType: FeatureType,
  description: string;
  snomedid: string;
  parentid: string;
  cost: number;
}

export interface WAttribute extends WPileEntity {
  name: string;
  description: string;
  attributeType: FeatureType,
  snomedid: string;
}

export interface WPanel extends WPileEntity {
  name: string;
  description: string;
  panelType: FeatureType,
  snomedid: string;
  loincid: string;
  findings?: WQualifiedFeature[];
}

export interface WRuleFeature {
  functionsAs: FunctionsAs;
  actsAs: ActsAs;
  featureid: string;
  procedureid?: string; // (optional) procedure for detecting target. i.e. use of X-RAY to detect certain finding
}

export interface WRuleProb {
  attributeids: string[];
  values: string[];
  rate: WRate;
}

export class WRate {
  low?: number = 0;
  high?: number = 0;
  denominator?: number = 1;
  freeText?: string;
}

export interface WPublication {
  publicationName?: string,
  chapter?: string,
  pageNumber?: string,
  comments?: string,
  url?: string,
}

export interface WCase extends WPileEntity {
  description: string;
  tags?: string[];
  panelids: string[];
  publication?: WPublication;

  // OLD
  evidences?: any;
  diagnoseDisorderids?: any;
  diagnoseTestids?: any;

  // NEW
  findings: WCaseQualifiedFeature[];
  diagnoses?: WDiagnose[];
  nextSteps?: WNextStep[];
  conditions?: WCaseCondition[]
  panelsToConsiders?: string[];
  patientCaseId?: string;
  patientCaseEtag?: string;
  freeTextComplaint?: string; // Maps to a general "data" field in the postgresql
}

export enum ConditionType {
  TOP_X = "TOP_X",
  NOT_TOP_X = "NOT_TOP_X",
  BEFORE = "BEFORE",
  AFTER = "AFTER",
  DISEASE_RANK = "DISEASE_RANK",
  RECOMMANDATION_RANK = "RECOMMANDATION_RANK",
  CONV_PATIENT_VOLUNTEER = "CONV_PATIENT_VOLUNTEER",

}
export enum ConditionDiseaseRank {
  CORRECT = 1,
  POSSIBLE = 2,
  UNLIKELY = 3,
  WRONG = 4,
}
export interface WCaseCondition {
  type: ConditionType;
  sortType: String;
  ddMode: string;
  payload: { feature?: WFeature, val?: number, selector?: FeatureTreeSelector }
  feature: WFeature
}

export interface WDiagnose {
  disorder: WQualifiedFeature;
}

export interface WNextStep {
  test: WQualifiedFeature;
}

export interface WDiscussion extends WPileEntity {
  entityid: string;
  remarks: WRemark[];
}

export interface WRemark {
  text: string;
  user: WUser;
  time: number;
}

export interface WCommit extends WEntity {
  description: string;
  commitDate: number;
  userid: string;
  user?: WUser;
  status: CommitStatus;
  pileid: string;
  comment: string;
}

export interface WPile extends WEntity {
  commitids: string[];
  ruleValueids: string[];
  featureids: string[];
  procedureids: string[];
  panelids: string[];
  attributeids: string[];
  caseids: string[];
  createDate: Date;
}

export interface WEvidence {
  node: WFeatureNode;
  value: string;
}

export enum CommitStatus {
  CREATED = "CREATED",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  RESUBMITTED = "RESUBMITTED"
}

export interface WUser extends WEntity {
  firstName: string,
  lastName: string,
  email: string
}

export interface WSnomedConcept extends WEntity {
  term: string;
}

export interface WLoincComponent extends WEntity {
  term: string;
}

export interface WDiagnoseGoalProb {
  featureids: string[];
  prob: number;
  weight: number;
  score: number;
}

export interface WDiagnoseTestValue {
  testNode: WFeatureNode;
  value: number;
  cost: number;
  score: number;
}

export interface DeleteFeatureRequest {
  forceModeration?: boolean;
}

export interface SaveEntitiesRequest {
  features?: WFeature[];
  relations?: WRelation[];
  ruleValues?: WRuleValue[];
  cases?: WCase[];
  policies?: WPolicy[];
  protocols?: WProtocol[];
  commitComment?: string;
  parentCommitid?: string;
  forceModeration?: boolean;
}

export interface SaveFeatureRequest {
  feature: WFeature;
  commitComment?: string;
  parentCommitid?: string;
  snomedTreeMatch?: boolean;
  forceModeration?: boolean;
  translations?: SaveEntityTranslation[];
}

export interface SaveProcedureRequest {
  procedure: WProcedure;
  commitComment?: string;
  parentCommitid?: string;
}

export interface SaveAttributeRequest {
  attribute: WAttribute;
  commitComment?: string;
  parentCommitid?: string;
}

export interface SavePanelRequest {
  panel: WPanel;
  commitComment?: string;
  parentCommitid?: string;
}

export interface SaveCaseRequest {
  wcase: WCase;
  commitComment?: string;
  parentCommitid?: string;
}

export interface SaveRepositoryEntityRequest {
  repositoryEntity: WRepositoryEntity;
}

export interface SaveEntitiesResponse {
  status: string;
  features: WFeature[];
  relations: WRelation[];
  ruleValues: WRuleValue[];
  cases: WCase[];
  policies: WPolicy[];
  protocols: WProtocol[];
  commit: WCommit;
}

export interface SaveFeatureResponse {
  status: string;
  feature: WFeature;
  newParents?: WFeature[];
  newChildren?: WFeature[];
}

export interface SaveProcedureResponse {
  status: string;
  procedure: WProcedure;
}

export interface SaveAttributeResponse {
  status: string;
  attribute: WAttribute;
}

export interface SavePanelResponse {
  status: string;
  panel: WPanel;
}

export interface SaveCaseResponse {
  status: string;
  wcase: WCase;
}

export interface SaveRepositoryEntityResponse {
  status: string;
  repositoryEnity: WRepositoryEntity;
}

export interface SaveRuleRequest {
  ruleValues: WRuleValue[];
  commitComment?: string;
  parentCommitid?: string;
  forceOverride?: boolean;
}

export interface SelectRulesRequest {
  featureid?: string;
  sourceFeatureid?: string;
  sourceRelationid?: string;
  targetFeatureid?: string;
  targetRelationid?: string;
  includeInherited?: boolean;
  citationid?: string;
  units?: RuleUnits;
  causalDirection?: CausalDirection;
  onlyLatest?: boolean;
  startMillis?: number;
  endMillis?: number;
  userid?: string;
  startAt?: number;
  limit?: number;
  orderBy?: RulesOrderBy[];
  order?: Order;
  status?: CommitStatus[];
  phase?: EntityPhase[];
  includeLlmMaster?: boolean;
}

export interface SelectRulesResponse {
  ruleValues: WRuleValue[];
  totalCount: number;
  store: WStore
}

export interface SelectProtocolResponse {
  protocol: WProtocol;
  store: WStore
}

export interface SelectCitationsRequest {
  term?: string;
  usesFeatureId?: string;
  usesFeatureInCriteriaId?: string;
  createdByUserId?: string;
  modifiedByUserId?: string;
  startAt?: number,
  limit?: number,
  orderBy?: CitationsOrderBy[],
  order?: Order,
  isLlmMaster?: boolean;
  copyFromCitationId?: string;
}

export enum RulesOrderBy {
  CREATED_AT = "CREATED_AT",
  LAST_MODIFIED_AT = "LAST_MODIFIED_AT",
  CREATED_BY = "CREATED_BY",
  CITATION_URL = "CITATION_URL",
  CAUSALITY = "CAUSALITY",
  FEATURE_NAME = "FEATURE_NAME"
}

export enum CitationsOrderBy {
  CREATED_AT="CREATED_AT",
  LAST_MODIFIED_AT="LAST_MODIFIED_AT",
  CREATED_BY="CREATED_BY",
  LAST_MODIFIED_BY="LAST_MODIFIED_BY",
  TITLE="TITLE",
  JOURNAL="JOURNAL",
  PUBLISHED="PUBLISHED"
}

export enum Order {
  ASC = "ASC",
  DESC = "DESC"
}

export interface SaveRuleResponse {
  status: string;
  ruleid: string;
  ruleValues: WRuleValue[];
  commit: WCommit;
  store: WStore;
}

export interface ImportResponse {
  success: boolean;
  messages: string[];
}

export interface DiagnoseRequest {
  evidences: WEvidence[];
}

export interface DiagnoseResponse {
  status: string;
  diagnoseid: string;
}

export interface DiagnoseGoalReasoningRequest {
  disorderids: string[];
  evidences: WEvidence[];
  panelids: string[];
}

//=== Relations And Qualifiers ====================================

export interface WRelation extends WPileEntity, WNamedEntity, WQualifiedEntity {
  range: WFeatureSet[];
  type: RelationType;
  normal?: WFeatureSet;
  snomedid?: string;
  essence?: RelationEssence;
  inheritance?: RelationInheritance;
}

export enum RelationType {
  Closed = "CLOSED",
  Open = "OPEN",
  Concrete = "CONCRETE" // NOT IN USE
}

export enum RelationEssence {
  STANDARD = "STANDARD",
  PROPERTY = "PROPERTY"
}

export enum RelationInheritance {
  INHERITED = "INHERITED",
  NOT_INHERITED = "NOT_INHERITED"
}

export enum FeatureTreeSelector {
  Self = "Self",
  SelfAndDescendants = "SelfAndDescendants",
  Descendants = "Descendants"
}

export class WFeatureSet {
  feature?: WFeature;
  constructor(
      public featureid: string,
      public selector: FeatureTreeSelector = FeatureTreeSelector.Self) { }
}

export interface WFeatureQualifier extends WQualifier {
  //   (1) In case "qualifierValue" is specified, the qualifier becomes part of the feature spec
  //   (2) Feature children inherit the "relation" and may "subtype" it or (if "qualifierValue" is absent)
  //       may specify any legal feature for this relation
  //   (3) Item (2) above applies also to the "WQualifiedFeature" part in rules that use the feature
  patientFacingQualifier?: WFeature;
  mandatory: boolean;
  editable: boolean;
  patientMandatory: boolean;
  stated?: boolean;
}


// ==================== Enable editing RuleValues  ======================
export enum RuleUnits {
  PERCENT = "PERCENT",
  LIFETIME_PERRCENT = "LIFETIME_PERRCENT",
  INCIDENCE = "INCIDENCE",
  LIFT = "LIFT",
  SPECIFICITY = "SPECIFICITY",
  ODDS_RATIO = "ODDS_RATIO",
  PPV = "PPV",
  NPV = "NPV",
  PLR = "PLR",
  NLR = "NLR",
  HAZARD_RATIO = "HAZARD_RATIO",
  RELATIVE_RISK = "RELATIVE_RISK",
}

// replacing WRuleProb
export class WRuleRate {
  sources: WQualifiedFeature[] = [];
  targets: WQualifiedFeature[] = [];
  units: RuleUnits = RuleUnits.PERCENT;
  causality: CausalDirection = CausalDirection.ASSOCIATION;
  rate: WRate;
  exact?: boolean;
  subRates: WRuleSubRate[];
  exposureGroup: WQualifiedFeature[] = [];
  background?: WQualifiedFeature[];
  sampleSize?: number;
  editorMetaData: any; // used by the editor for data annotations
  localizationScope?: WFeature;
}

export enum SubRateType {
  ConstrainSource = "ConstrainSource",
  ConstrainTarget = "ConstrainTarget",
  Distribute = "Distribute",
  ExposureGroup = "ExposureGroup"
}


export class WRuleSubRate {
  qualifiedFeature: WQualifiedFeature;
  type: SubRateType = SubRateType.Distribute;
  rate: WRate;
}

export interface WCitation extends WPileEntity {
  url?: string;
  rawData?: { fileType: CitationFileType; rawFile: string | Map<string, any>} [];
  citeData?: Map<string, any> | object;
  metaData?: Map<string, any>;
  scores?: Map<CitationScoreType, number>;
}


export class WQualifiedFeature {
  constructor(public feature: WFeature,
              public qualifiers: WQualifier[] = [],
              public procedure?: WProcedure) { }
  public negate?: boolean;
}

export class WCaseQualifiedFeature extends WQualifiedFeature {
  constructor(public feature: WFeature,
              public qualifiers: WQualifier[] = [],
              public procedure?: WProcedure,
              public presentationType = FindingPresentationType.ACTIVE_FINDING,
              public skip: boolean = false,
              public source: FindingSource = FindingSource.PHYSICIAN) {
    super(feature, qualifiers, procedure)
  }
}

// relation is required. in addition, one could specify exactly one of the 3 options:
// 1. feature + negate
// 2. range
// 3. distribution
export class WBaseQualifier {
  constructor(public relation: WRelation,
              public feature?: WFeature) { }
  public range?: WMeasurementRange;
}

export class WQualifier extends WBaseQualifier {
  constructor(public relation: WRelation,
              public feature?: WFeature) {
    super(relation, feature);
  }
  public negate?: boolean;
  public range?: WMeasurementRange;
  public group?: string;
  public freeText?: string;
  public source?: FindingSource;
  public encrypted?: string;
}

export type WNewRulePage = WFeatureEditPage;


export class WKnownEntities {
  static entities: { [s: string]: any } = {};
}

export type SelectFeatureSet = (sets: Array<WFeatureSet>, search?: string) => Promise<{ store: WStore; rootids: string[]; }>
export type SelectRelationValues = (featureid: string, relationid: string, search?: string) => Promise<WFeature[]>


export class WKBProblem {
  kind: string;
  entity: WPileEntity;
  message: string;
}

export class ExternalData {
  synonyms: Synonym[];
}

export enum ExternalDatabase {
  SNOMED = "snomed", LOINC = "loinc",WIKIPEDIA ="wikipedia", HUMAN_DISEASE_ONTLOGY ="humanDiseaseOntlogy",KAHUN = "kahun"
}

export class Synonym {
  text: string;
  externalDatabase: ExternalDatabase;
  externalId: string;
  langCode: string;
  tags: string[];
  type: SynonymType;
}

export class WTerm {
  name: string;
  type: TermType;
  langCode: string;
  specified: boolean;
  url?: string;
  bodyReference?: TermBodyReference;
}

export enum ExternalDatabase {
  snomed = "snomed", loinc = "loinc", wikipedia = "wikipedia", humanDiseaseOntlogy = "humanDiseaseOntlogy", kahun = "kahun"
}

export enum TermType {
  SHORT = "SHORT",
  THE_SHORT = "THE_SHORT",
  APP = "APP",
  DESCRIPTION = "DESCRIPTION",
  PATIENT_QUESTION = "PATIENT_QUESTION",
  PATIENT_SHORT_QUESTION = "PATIENT_SHORT_QUESTION",
  PATIENT_DESCRIPTION  = "PATIENT_DESCRIPTION",
  PATIENT_REFINEMENT = "PATIENT_REFINEMENT",
  THE_PATIENT_REFINEMENT = "THE_PATIENT_REFINEMENT",
  PATIENT_FOLLOWUP_QUESTION = "PATIENT_FOLLOWUP_QUESTION",
}

export enum TermBodyReference {
  MALE_SINGLE = "MALE_SINGLE",
  MALE_PLURAL = "MALE_PLURAL",
  FEMALE_SINGLE = "FEMALE_SINGLE",
  FEMALE_PLURAL = "FEMALE_PLURAL"
}

export enum SynonymType {
  Description = "Description",
  Name = "Name",
}

export enum CitationFileType {
  RIS = "ris",
  BIBTEX = "bibtex",
  // Manual are bibliography files created manually by users
  MANUAL = "manual",
  // Internal are used for citation page
  INTERNAL = "internal",
  // Temporary are citations holding only a url and are waiting to be translated
  // into full citation files (bibtex/ris) by a background service worker
  TEMPORARY = "temporary"
}

export enum CitationScoreType {
  SJR = "SJR",
  HIndex = "HIndex"
}

export enum FindingPresentationType {
  BACKGROUND_FINDING = "BACKGROUND_FINDING",
  ACTIVE_FINDING = "ACTIVE_FINDING",
  MAIN_FINDING = "MAIN_FINDING"
}

export enum FindingPresentationTypeNames {
  BACKGROUND_FINDING = "Background",
  ACTIVE_FINDING = "Active",
  MAIN_FINDING = "Complaint"
}

export enum FindingSource {
  PATIENT = "PATIENT",
  PATIENT_VOLUNTEER = "PATIENT_VOLUNTEER",
  PATIENT_FREE_TEXT = "PATIENT_FREE_TEXT",
  PHYSICIAN = "PHYSICIAN",
  EHR = "EHR",
  IMPLIED = "IMPLIED",
  POSSIBLE = "POSSIBLE",
  CRITERIA = "CRITERIA"
}
